export const apiBase = import.meta.env.VITE_API_BASE_URL || '/api';
const requestCache = new Map<string, { expiresAt: number; value?: unknown; pending?: Promise<unknown> }>();

function userCacheKey(token: string) {
  try { return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).sub || 'session'; }
  catch { return 'session'; }
}

function cacheTtl(path: string) {
  if (path === '/me' || path === '/billing') return 5 * 60_000;
  if (path === '/dashboard' || path === '/customers' || path === '/team' || path === '/visits') return 30_000;
  return 0;
}

export async function api<T>(path: string, token: string, init?: RequestInit): Promise<T> {
  const method = (init?.method || 'GET').toUpperCase();
  const ttl = method === 'GET' ? cacheTtl(path) : 0;
  const key = `${userCacheKey(token)}:${path}`;
  const current = requestCache.get(key);
  if (ttl && current && current.expiresAt > Date.now()) return (current.pending ? await current.pending : current.value) as T;
  if (method !== 'GET') requestCache.clear();
  const request = fetch(`${apiBase}${path}`, {
    ...init,
    headers: { Authorization: `Bearer ${token}`, 'content-type': 'application/json', ...init?.headers },
  }).then(async (response) => {
  if (!response.headers.get('content-type')?.includes('application/json')) {
    throw new Error('La sesión del sitio no corresponde a esta cuenta.');
  }
  const data = await response.json().catch(() => ({})) as { message?: string };
  if (!response.ok) throw new Error(data.message ?? `${path} devolvió HTTP ${response.status}`);
  return data as T;
  });
  if (ttl) requestCache.set(key, { expiresAt: Date.now() + ttl, pending: request });
  try {
    const value = await request;
    if (ttl) requestCache.set(key, { expiresAt: Date.now() + ttl, value });
    return value;
  } catch (error) {
    requestCache.delete(key);
    throw error;
  }
}
